import React, {useState, useEffect} from 'react';
import {HeadEmpreas} from './HeadEmpreas';
import {MenuLateralAB} from '../menuLateralAA/MenuLateralAB';
import {Empresa} from './Empresa';
import {FormularioEmpresaAdmin} from './FormularioEmpresaAdmin';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {useSessionStore} from '../../hooks/useSessionStore';
import axios from 'axios';
import {Paginador} from '../varios/Paginador';
import {animateScroll as scroll} from 'react-scroll';

export const ContentBodyEmpresas = (props) => {
	const {MenuLateralAux, chageMenuLateralAux} = props;
	/* A React Hook. It is a function that lets you “hook into” React state and lifecycle features from
    function components. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

	/* A React Hook. It is a function that lets you “hook into” React state and lifecycle features from
    function components. */
	const [NumPagina, setNumPagina] = useState(1);

	/* A React Hook. It is a function that lets you “hook into” React state and lifecycle features from
    function components. */
	const [MaxPages, setMaxPages] = useState();

	/* A React Hook. It is a function that lets you “hook into” React state and lifecycle features from
    function components. */
	const [TypeSev, setTypeServ] = useState('pendiente');

	/* A React Hook. It is a function that lets you “hook into” React state and lifecycle features from
    function components. */
	const [nombreEmpresa, setNombreEmpresa] = useState('');

	/* A React Hook. It is a function that lets you “hook into” React state and lifecycle features from
    function components. */
	const [emailEmpresa, setEmailEmpresa] = useState('');

	/* A React Hook. It is a function that lets you “hook into” React state and lifecycle features from
    function components. */
	const [pantallaPerfil, setPantallaPerfil] = useState(false);

	/* A React Hook. It is a function that lets you “hook into” React state and lifecycle features from
    function components. */
	const [idEmpresa, setIdEmpresa] = useState();

	/* A React Hook. It is a function that lets you “hook into” React state and lifecycle features from
    function components. */
	const [ListaEmpresas, setListaEmpresas] = useState([]);

	const guardarCambios = () => {};

	const borrarCuenta = () => {};

	const definirEmpresas = (page, tipe) => {
		/* Setting a default value for the variable `numpage` if the argument `page` is undefined. */
		let numpage = 1;
		if (page != undefined) {
			numpage = page;
		}
		/* Checking if the argument `tipe` is undefined. If it is, then it sets the variable `tipe` to
        the state of the component `TypeSev`. */
		if (tipe === undefined) {
			tipe = TypeSev;
		}
		axios({
			/* Making a GET request to the URL `http://localhost:8000/prestadorServiciosAdmin/?page=' +
            numpage + "&type=" + tipe` with the header `"Authorization": "Bearer " + Usuario.access` */
			method: 'get',
			url: window.ipdirection + 'prestadorServiciosAdmin/?page=' + numpage + '&type=' + tipe,
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		}).then((response) => {
			let listaAxu = [];
			/* Iterating over the list `response.data.results` and pushing each element of the list
                into the list `listaAxu`. */
			response.data.results.map((empresa) => {
				listaAxu.push(empresa);
			});
			setListaEmpresas(listaAxu);
			setMaxPages(() => {
				/* Setting the variable `rendondeado` to the integer part of the division of
                    `response.data.count` by 10. */
				let rendondeado = Math.trunc(response.data.count / 10);
				/* Checking if the difference between `response.data.count` and the product of
                    `rendondeado` and 10 is greater than 0. */
				if (response.data.count - rendondeado * 10 > 0) {
					return rendondeado + 1;
				} else {
					return rendondeado;
				}
			});
		});
	};

	/* A React Hook. It is a function that lets you “hook into” React state and lifecycle features from
    function components. */
	useEffect(() => {
		/* Calling the function `definirEmpresas` with the arguments `1` and `"pendiente"`. */
		definirEmpresas(1, 'pendiente');
	}, []);

	const [Seleccion, setSeleecion] = useState([
		['buttonNotificacionesActive', 'Pendientes'],
		['buttonNotificaciones', 'Activos'],
		['buttonNotificaciones', 'Innactivos'],
	]);
	/**
	 * It takes a number as an argument and then sets the state of the component to a list of strings,
	 * where the string at the index of the number argument is set to a different string
	 */
	const cambioSeleccion = (num) => {
		scroll.scrollToTop();
		setNumPagina(1);
		/* Setting the state of the component to a list of strings, where the string at the index of
        the number argument is set to a different string. */
		let listaAxu = [
			['buttonNotificaciones', 'Pendientes'],
			['buttonNotificaciones', 'Activos'],
			['buttonNotificaciones', 'Innactivos'],
		];
		listaAxu[num] = ['buttonNotificacionesActive', listaAxu[num][1]];
		setSeleecion(listaAxu);

		// Definimos el tipo de empresa y las volvemos a cargar
		/* Checking if the argument `num` is equal to 0. If it is, then it calls the function
        `definirEmpresas` with the arguments `1` and `"pendiente"`, and then sets the state of the
        component to
        `"pendiente"`. If the argument `num` is not equal to 0, then it checks if it is equal to 1.
        If it is,
        then it calls the function `definirEmpresas` with the arguments `1` and `"activo"`, and then
        sets the
        state of the component to `"activo"`. If the argument `num` is not equal to 1, then it sets
        the state of
        the component to `"innactivo"` and calls the function `definirEmpresas` with the arguments
        `1` and
        `"innactivo"`. */
		if (num === 0) {
			definirEmpresas(1, 'pendiente');
			setTypeServ('pendiente');
		} else {
			if (num === 1) {
				definirEmpresas(1, 'activo');
				setTypeServ('activo');
			} else {
				definirEmpresas(1, 'innactivo');
				setTypeServ('innactivo');
			}
		}
	};

	return (
		<>
			<MenuLateralAB
				seleccionado={7}
				MenuLateralAux={MenuLateralAux}
				chageMenuLateralAux={chageMenuLateralAux}
			/>
			<div className='ContentUserFeedback'>
				{pantallaPerfil ? (
					<FormularioEmpresaAdmin
						guardarCambios={guardarCambios}
						borrarCuenta={borrarCuenta}
						setPantallaPerfil={setPantallaPerfil}
						idEmpresa={idEmpresa}
						atras={() => {
							scroll.scrollToTop();
							definirEmpresas();
							setPantallaPerfil(false);
						}}
					/>
				) : (
					<div className='derContentUserFeedback'>
						<HeadEmpreas
							nombreEmpresa={nombreEmpresa}
							setNombreEmpresa={setNombreEmpresa}
							emailEmpresa={emailEmpresa}
							setEmailEmpresa={setEmailEmpresa}
							Seleccion={Seleccion}
							cambioSeleccion={cambioSeleccion}
						/>
						<div className='lista-empresas'>
							{ListaEmpresas.map(
								(empresa, index) =>
									empresa.nombreEmpresa
										.toLowerCase()
										.includes(nombreEmpresa.toLowerCase()) &&
									empresa.emailEmpresa
										.toLowerCase()
										.includes(emailEmpresa.toLowerCase()) && (
										<Empresa
											empresa={empresa}
											setPantallaPerfil={setPantallaPerfil}
											selectEmpresa={setIdEmpresa}
										/>
									)
							)}
							<Paginador
								NumPagina={NumPagina}
								setNumPagina={setNumPagina}
								onChange={definirEmpresas}
								TypeSev={TypeSev}
								MaxPages={MaxPages}
							/>
						</div>
					</div>
				)}
			</div>
		</>
	);
};

/**
 
    const Empresa = {

        descripcionEmpresa: '',
        notasEmpresa: '',

        lenguajeEmpresa: '',
        tamañoEmpresa: '',

        tiposcuidados:[

        ]

    }


 */
